import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { PathGraphFlowRunMode } from '../generated/types.js';
import deriveNodeNavigationDetails from '../helpers/deriveNodeNavigationDetails.js';
import deriveOnCompleteActions from '../helpers/deriveOnCompleteActions.js';
import { useCreatePathGraphFlowMutation } from '../mutations/CreatePathGraphFlow.generated.js';

function useCreatePath(_ref) {
  var onPathCreated = _ref.onPathCreated,
      onPathCompleted = _ref.onPathCompleted,
      onError = _ref.onError;

  var _useCreatePathGraphFl = useCreatePathGraphFlowMutation({
    onCompleted: function onCompleted(_ref2) {
      var createPathGraphFlow = _ref2.createPathGraphFlow;

      if (createPathGraphFlow.error) {
        onError && onError(createPathGraphFlow.error);
        return;
      }

      if (createPathGraphFlow.pathGraphFlow) {
        /**
         * Check the existence of the the tracking client within the useCreatePath since this could
         * be individually imported outside of the main `Path` component.
         */
        if (window.tracking && createPathGraphFlow.pathGraphFlow.runMode !== PathGraphFlowRunMode.DRY_RUN) {
          window.tracking.events.trackPathClientFlowCreated({
            path_graph_flow_id: createPathGraphFlow.pathGraphFlow.id,
            source_key: createPathGraphFlow.pathGraphFlow.sourceKey || ''
          });
        } else {
          console.warn('Attempted to track `PathClientFlowCreated` without available trackingClient');
        }
        /**
         * With enough initial attribute data, it's theoretically possible to complete a path before
         * you even visit it. Check to see if this happens and handle.
         */


        var initialNode = _toConsumableArray(createPathGraphFlow.pathGraphFlow.nodes).pop();

        if (createPathGraphFlow.pathGraphFlow.completed) {
          if (onPathCompleted && initialNode) {
            var onCompleteActions = deriveOnCompleteActions(initialNode);
            onPathCompleted(Object.assign({
              pathNavigationDetails: {
                nodeSlugOrId: initialNode.id,
                pathGraphFlowId: createPathGraphFlow.pathGraphFlow.id,
                pathGraphFlowSlug: initialNode.pathGraphSlug
              },
              requestEvents: createPathGraphFlow.pathGraphFlow.requestEvents
            }, onCompleteActions));
          } else {
            console.warn('Path completed without an onComplete action');
          }

          return;
        }
        /**
         * Hard failures if there is a path that is created without any nodes but isn't completed.
         */


        if (!initialNode) {
          throw new Error('Path created without any nodes');
        }
        /**
         * When starting a path, if a slug exists (for questions or intersitials) then attempt to use
         * that as the node identifier. If not, fallback to an ID.
         */


        var nodeCompletionDetails = deriveNodeNavigationDetails(initialNode);
        onPathCreated({
          pathGraphFlowId: createPathGraphFlow.pathGraphFlow.id,
          pathGraphFlowSlug: nodeCompletionDetails.pathSlug,
          nodeSlugOrId: nodeCompletionDetails.nodeSlug || nodeCompletionDetails.nodeId
        });
      }
    }
  }),
      _useCreatePathGraphFl2 = _slicedToArray(_useCreatePathGraphFl, 2),
      createPathGraphFlow = _useCreatePathGraphFl2[0],
      loading = _useCreatePathGraphFl2[1].loading;

  return [function (createInput) {
    createPathGraphFlow({
      variables: {
        input: createInput
      }
    });
  }, {
    loading: loading
  }];
}

export default useCreatePath;
//# sourceMappingURL=useCreatePath.js.map
